import PropertiesIcon from '@mui/icons-material/AccountBalance';
import VendorsIcon from '@mui/icons-material/Construction';
import WorkOrdersIcon from '@mui/icons-material/ContentPaste';
import UsersIcon from '@mui/icons-material/People';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Configuration, CONFIGURATION_TYPE } from 'vendor-marketplace-shared-library';
import { getConfigurationValue } from '../../utilities/helpers';
import useConfigurations from '../../hooks/useConfigurations';

export default function NavBar() {
  const navigate = useNavigate();
  const { configurationsQuery } = useConfigurations();
  const userConciergeVendorsIsEnabledConfiguration =
    configurationsQuery?.data?.getConfigurations?.find(
      (configuration: Configuration) =>
        configuration.name === CONFIGURATION_TYPE.CONCIERGE_VENDORS_IS_ENABLED,
    );

  const isUserConciergeVendorsEnabled = getConfigurationValue(
    userConciergeVendorsIsEnabledConfiguration,
  );

  const navOptions = [
    {
      title: 'Work Orders',
      Icon: <WorkOrdersIcon />,
      onClick: () => navigate('/'),
      show: true,
      highlighted: window.location.pathname === '/',
    },
    {
      title: 'Properties',
      Icon: <PropertiesIcon />,
      onClick: () => navigate('/properties'),
      show: true,
      highlighted: window.location.pathname.startsWith('/properties'),
    },
    {
      title: 'Users',
      Icon: <UsersIcon />,
      onClick: () => navigate('/users'),
      show: true,
      highlighted: window.location.pathname.startsWith('/users'),
    },
    {
      title: 'Vendors',
      Icon: <VendorsIcon />,
      onClick: () => navigate('/vendors'),
      show: isUserConciergeVendorsEnabled,
      highlighted: window.location.pathname.startsWith('/vendors'),
    },
    {
      title: 'Settings',
      Icon: <SettingsOutlinedIcon />,
      onClick: () => navigate('/settings'),
      show: true,
      highlighted: window.location.pathname.startsWith('/settings'),
    },
  ];

  return (
    <div>
      <Toolbar>
        <img src={'/procure-logo.png'} alt={'ProCure Logo'} height={50} />
      </Toolbar>
      <Divider />
      <List>
        {navOptions
          .filter(option => option.show)
          .map((navOption, index) => (
            <ListItem key={navOption.title} disablePadding>
              <ListItemButton onClick={navOption.onClick}>
                <ListItemIcon
                  sx={{
                    color: navOption.highlighted ? 'primary.main' : 'white',
                  }}
                >
                  {navOption.Icon}
                </ListItemIcon>
                <ListItemText sx={{ color: 'white' }} primary={navOption.title} />
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </div>
  );
}
